import { forwardRef } from "react"
import styles from "./StickerPopover.module.scss"
import { Sticker } from "../../models/sticker"
import cn from "classnames"
import { StickersList } from "./StickersList"

export interface StickerPopoverProps {
    setSticker: (sticker: Sticker) => void
    stickers: Sticker[]
}

const ArticleStickerPopover = forwardRef<HTMLDivElement, StickerPopoverProps>((props, ref) => {
    const { setSticker, stickers } = props

    return (
        <div ref={ref} className={cn(!stickers.length && styles.root_noStickers)}>
            <StickersList stickers={stickers} onStickerClick={setSticker} />
        </div>
    )
})

export default ArticleStickerPopover
